import { Card, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DashedBorderTitle } from "../../../../Constant";
import { DASHED_BORDER, DASHED_BORDER_BODY, DASHED_BORDER_HEAD } from "../../../../Data/BootstrapTable/BasicTable";
import CommonTable from "../Common/CommonTable";

export const DashedBorder=()=> {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={DashedBorderTitle} span={DASHED_BORDER} />
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable tableClass="table-dashed" headData={DASHED_BORDER_HEAD}>
              {DASHED_BORDER_BODY.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.activity}</td>
                  <td>{data.category}</td>
                  <td>{data.time}</td>
                  <td>{data.instructor}</td>
                  <td>{data.capacity}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
